import { RSAA } from 'redux-api-middleware';
import { APP } from 'actions/appActions';
import { SESSION } from 'actions/sessionActions';
import { AFSP, generateRequestObject, submitProviderRegistration  } from 'utils/reqUtils';
import { Base64 } from 'js-base64';
import store from 'store';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { getDataType, setEnvPrefix } = ssCommonUtils;

export function onPortalTypeChange( newPortalType ) {
    store.dispatch( {
        type: APP.SET_PORTAL_TYPE,
        payload: {
            portalType: newPortalType
        }
    } );
}

export function togglePasswordUpdateView() {
    return { type: APP.TOGGLE_PASSWORD_UPDATE_VIEW };
}

export function setData( type, data ) {
    let
    action,
    R = APP.REGISTRATION,
    L = APP.LOGIN,
    { REQUEST } = APP;

    switch ( type ) {
        case 'personal':
            action = R.SET_PERSONAL;
            break;
        case 'passport':
            action = R.SET_PASSPORT;
            break;
        case 'security':
            action = R.SET_SECURITY;
            break;
        case 'email':
            action = R.SET_EMAIL;
            break;
        case 'signature':
            action = R.SET_SIGNATURE;
            break;
        case 'login':
            action = L.SET_LOGIN;
            break;
        case 'forgotten':
            action = L.SET_FORGOTTEN;
            break;
        case 'changeEmail':
            action = L.SET_CHANGE_EMAIL;
            break;
        case 'provider':
            action = R.SET_PROVIDER;
        case 'submit':
            action = R.SET_SUBMIT;
            break;
        case R.SET_CAPTCHA_BASE64:
            action = R.SET_CAPTCHA_BASE64;
            break;
        case REQUEST.REGISTRATION.RESET:
            action = REQUEST.REGISTRATION.RESET;
            break;
        case REQUEST.HOME.LOGIN.RESET:
            action = REQUEST.HOME.LOGIN.RESET;
            break;
        case REQUEST.HOME.FORGOT.RESET:
            action = REQUEST.HOME.FORGOT.RESET;
            break;
        case REQUEST.CHECK_RESET:
            action = REQUEST.CHECK_RESET;
            break;
        case REQUEST.CHECK_PENDING:
            action = REQUEST.CHECK_PENDING;
            break;
        case REQUEST.CHECK_SUCCESS:
            action = REQUEST.CHECK_SUCCESS;
            break;
        case REQUEST.CHECK_FAILURE:
            action = REQUEST.CHECK_FAILURE;
            break;
        case REQUEST.CAPTCHA.VALIDATION.RESET:
            action = REQUEST.CAPTCHA.VALIDATION.RESET;
            break;
    }

    return { type: action, payload: data };
}

export function doRequest(r, d) {
    d = generateRequestObject(r, d);

    if (d.hasOwnProperty('error')) {
        console.error(d.error.msg);
        return d;
    } else {
        const { REGISTRATION, CAPTCHA, HOME, CHECK } = APP.REQUEST;

        // Used to inject the reponse code regardless of overall status.
        let meta = ( action, state, response ) => ( { code: response.status } );

        // Added a function to each case to inject the response code itself as part fo the
        // request the comes back. This way, regardless of the status of the request, the status
        // code will also be present.
        switch ( r ) {
            case AFSP.TYPE.POST_CAPTCHA:
                return {
                    [ RSAA ]: {
                        ...d,
                        types: [
                            {
                                type: CAPTCHA.VALIDATION.PENDING
                            }, {
                                type: CAPTCHA.VALIDATION.SUCCESS
                            }, {
                                type: CAPTCHA.VALIDATION.FAILURE
                            }
                        ]
                    }
                };
            case AFSP.TYPE.GET_CAPTCHA:
                return ajax( {
                    ...d,
                    types: [
                        CAPTCHA.PENDING, {
                            type: CAPTCHA.SUCCESS,
                            payload: ( action, status, response ) => {
                                store.dispatch( { type: APP.REGISTRATION.SET_CAPTCHA_BASE64, payload: response } );
                                return { type: action };
                            }
                        },
                        CAPTCHA.FAILURE
                    ]
                } );
            case AFSP.TYPE.REGISTRATION:
                return {
                    [ RSAA ]: {
                        ...d,
                        types: [
                            {
                                type: REGISTRATION.PENDING,
                                meta: {
                                    code: 0
                                }
                            }, {
                                type: REGISTRATION.SUCCESS,
                                meta: meta
                            }, {
                                type: REGISTRATION.FAILURE,
                                meta: meta
                            }
                        ]
                    }
                };
            case AFSP.TYPE.PROVIDER_REGISTRATION:
                return {
                    [ RSAA ]: {
                        ...d,
                        types: [
                            {
                                type: REGISTRATION.PENDING,
                                meta: {
                                    code: 0
                                }
                            }, {
                                type: REGISTRATION.SUCCESS,
                                meta: meta
                            }, {
                                type: REGISTRATION.FAILURE,
                                meta: meta
                            }
                        ]
                    }
                }
            case AFSP.TYPE.LOGIN:
                return {
                    [ RSAA ]: {
                        ...d,
                        types: [
                            {
                                type: HOME.LOGIN.PENDING,
                                meta: {
                                    code: 0
                                }
                            }, {
                                type: HOME.LOGIN.SUCCESS,
                                meta: ( action, state, response ) => {
                                    var data = {},
                                        token = response
                                            .headers
                                            .get( 'Authorization' ),
                                        tokenSet = token.split( '.' );

                                    // Go through the tokens and build the 'data' object that will be stored in the session
                                    // state.
                                    tokenSet.forEach( ( item, index ) => {
                                        if ( index < ( tokenSet.length - 1 ) ) {
                                            var obj = JSON.parse( Base64.decode( item ) );
                                            for ( var p in obj )
                                                data[ p ] = obj[ p ];
                                            }
                                        else if ( index === ( tokenSet.length - 1 ) )
                                            data.hash = item;
                                        }
                                    );

                                    // Pass this information to the session reducer by calling one of its actions to set the
                                    // data for the session.
                                    store.dispatch( {
                                        type: SESSION.SET_SESSION,
                                        payload: {
                                            active: true,
                                            token: token,
                                            data: data
                                        }
                                    } );

                                    return { code: response.code };
                                }
                            }, {
                                type: HOME.LOGIN.FAILURE,
                                meta: meta
                            }
                        ]
                    }
                };
            case AFSP.TYPE.CHECK:
                var t = { type: CHECK };
                return { [RSAA]: {...d.request,
                    types: [
                        {...t, meta: { status: 'pending', data: d.meta, code: 0 }}, 
                        {...t, meta: (action, state, response) => ({ status: 'success', data: d.meta, code: response.status })}, 
                        {...t, meta: (action, state, response) => ({ status: 'failure', data: d.meta, code: response.status })}
                    ]
                }};
            case AFSP.TYPE.PASSWORD_RESET_REQUEST:
                return { [RSAA]: {...d,
                    types: [
                        { type: HOME.FORGOT.PENDING, meta: { code: 0 }}, 
                        { type: HOME.FORGOT.SUCCESS, meta: meta }, 
                        { type: HOME.FORGOT.FAILURE, meta: meta }
                    ]
                }}
        }
    }
}

export function ajax( request ) {
    var resultData = {
            meta: {
                status: null,
                code: null
            },
            type: null,
            payload: null
        },
        xhr = new XMLHttpRequest(),
        // Use the configuration in the request to parse out the data from the response when
        // passing it back.
        dataFormatter = ( d ) => {
            if ( request.hasOwnProperty( 'headers' ) ) {
                for ( var h in request.headers ) {
                    var headerType = request.headers[ h ];
                    switch ( h ) {
                        case 'Content-Type':
                            switch ( headerType ) {
                                case 'application/json':
                                    d = JSON.parse( d );
                                    break;
                            }
                            break
                    }
                }
            }
            return d;
        },
        getContentType = () => {
            var contentType;
            for ( var h in request.headers ) {
                contentType = request.headers[ h ];
            }
            return contentType;
        };

    xhr.onreadystatechange = () => {
        const { readyState, status } = xhr;
        if ( readyState == XMLHttpRequest.DONE ) {
            var obj = {},
                success = request.types[1],
                failure = request.types[ 2 ];
            switch ( ( status + '' ).charAt( 0 ) ) {
                    // General success 2xx series of responses.
                case '2':
                    if ( getDataType( success ) === 'Object' ) {
                        store.dispatch( success.payload( success.type, status, xhr.responseText ) );
                    } else if ( getDataType( success ) === 'String' ) {
                        return {
                            ...returnData,
                            meta: {
                                status: 'success',
                                code: status
                            },
                            type: success,
                            payload: dataFormatter( xhr.responseText )
                        };
                    }
                    break;

                    // General failure with the 4xx series of responses.
                case '4':
                    if ( getDataType( failure ) === 'Object' ) {
                        store.dispatch( failure.payload( failure.type, status, xhr.responseText ) );
                    } else if ( getDataType( failure ) === 'String' ) {
                        return {
                            ...returnData,
                            meta: {
                                status: 'failure',
                                code: status
                            },
                            type: failure,
                            payload: dataFormatter( xhr.responseText )
                        };
                    }
                    break;
            }
        }
    }

    xhr.open( request.method, setEnvPrefix( request.endpoint ), true );
    xhr.setRequestHeader( 'Content-Type', getContentType() );

    switch ( request.method ) {
        case 'GET':
            xhr.send();
            break;
        case 'POST':
            xhr.send( request.body );
            break;
    }

    return { type: request.types[ 0 ] };
}

export function onClickGet( e, list, url ) {
    var target;

    for ( var i = 0; i < list.length; i++ ) {
        if ( list[ i ] === e ) {
            target = list[ i ];
            break;
        }
    }

    return {
        [ RSAA ]: {
            endpoint: url + '/' + target,
            method: 'GET',
            types: [ APP.ON_CLICK_GET_REQUEST, APP.ON_CLICK_GET_SUCCESS, APP.ON_CLICK_GET_FAILURE ]
        }
    }
}

////////////////////////////////////////////////////
export function getHomeFsdoLocations() {
    return {
        [ RSAA ]: {
            method: 'GET',
            endpoint: '/user/org/fsdo',
            types: [ APP.GET_FSDO_LOCATIONS_PENDING, APP.GET_FSDO_LOCATIONS_SUCCESS, APP.GET_FSDO_LOCATIONS_FAILURE ]
        }
    }
}

export function submitProviderRegistrationRequest(d, captcha) {
    let request = submitProviderRegistration(d, captcha);
    const { REGISTRATION } = APP.REQUEST;
    console.log('submit provider');
    console.log(request);

    return {
            [ RSAA ]: {
                ...request,
                types: [REGISTRATION.PENDING, REGISTRATION.SUCCESS, REGISTRATION.FAILURE]
            }
        }
}